import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Autocomplete,
	Button,
	Card,
	CardContent,
	Grid,
	Typography,
	Box,
	Stack
} from "@mui/material";
import TextField from "@mui/material/TextField";
import floatParser from "../../../helpers/floatParser";
import {ICalisanOdemeKayit, IHesap, IKalem} from "../../../constants/types/logbook";
import IconButton from "@mui/material/IconButton";
import {Delete, Undo, Payments, AddCircleOutline, ExpandMore} from "@mui/icons-material";

const Odemeler = (
	{
		personelOdemeleri,
		setPersonelOdemeleri,
		hesaplar,
	}: {
		personelOdemeleri: IKalem<ICalisanOdemeKayit>,
		setPersonelOdemeleri: any,
		hesaplar: IHesap[],
	}) => {
	return (
		<Accordion
			elevation={0}
			sx={{
				backgroundColor: 'background.paper',
				borderRadius: '16px !important',
				border: '1px solid rgba(0,0,0,0.05)',
				mb: 1,
				overflow: 'hidden',
				'&:before': { display: 'none' }
			}}
		>
			<AccordionSummary expandIcon={<ExpandMore />}>
				<Stack direction="row" spacing={1.5} alignItems="center">
					<Payments color="primary" />
					<Typography variant="h6" fontWeight={800} sx={{ textTransform: 'uppercase', letterSpacing: 1 }}>
						Personel Ödemeleri
					</Typography>
					<Typography variant="caption" sx={{ bgcolor: 'primary.main', color: 'white', px: 1, py: 0.2, borderRadius: 1, fontWeight: 700 }}>
						{personelOdemeleri.data.length + personelOdemeleri.eklenenListe.length} Kayıt
					</Typography>
				</Stack>
			</AccordionSummary>
			<AccordionDetails sx={{ bgcolor: '#fcfcfc', p: { xs: 1, md: 1.5 } }}>
				<Grid container spacing={1}>
				{
					personelOdemeleri.data.map((odeme, odemeIndex) => {
							const guncellenmis = personelOdemeleri.guncellenecekIdListe.includes(odeme.id ?? -1);
							const silinmis = personelOdemeleri.silinecekIdListe.includes(odeme.id ?? -1);
							if (guncellenmis) odeme = personelOdemeleri.guncellenecekListe[odeme.id ?? 0];
							const guncelle = (guncel: ICalisanOdemeKayit) => {
								setPersonelOdemeleri({
									...personelOdemeleri,
									guncellenecekIdListe: [...(guncellenmis ? personelOdemeleri.guncellenecekIdListe : [...personelOdemeleri.guncellenecekIdListe, odeme.id ?? 0])],
									guncellenecekListe: {...personelOdemeleri.guncellenecekListe, [odeme.id ?? 0]: guncel}
								})
							}
							return (
								<Grid item xs={12} key={"odeme-" + odemeIndex}>
									<Card
										elevation={0}
										sx={{
											border: '1px solid',
											borderColor: guncellenmis ? 'info.light' : silinmis ? 'error.light' : 'rgba(0,0,0,0.08)',
											backgroundColor: guncellenmis ? 'info.light' : silinmis ? '#fff5f5' : '#fff',
											borderRadius: '12px',
											transition: 'all 0.2s'
										}}
									>
										<CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
											<Grid container spacing={1} alignItems="center">
												<Grid item xs={12} sm={3}>
													<Autocomplete
														size={"small"}
														disabled={silinmis}
														options={["Avans", "Maaş", "Cari"]}
														renderInput={(params) => <TextField {...params} label="Ödeme Tipi"/>}
														value={odeme.tip}
														defaultValue={"Maaş"}
														onChange={(_event, value) => {
															const guncel = {...odeme};
															guncel.tip = value ?? "Maaş";
															guncelle(guncel);
														}}
													/>
												</Grid>
												<Grid item xs={12} sm={3}>
													<Autocomplete
														size={"small"}
														disabled={silinmis}
														disablePortal
														options={hesaplar.filter(q => q.hesapTipi !== "Çalışan").map(q => q.id)}
														getOptionLabel={option => hesaplar.find(q => q.id === option)?.hesapAdi ?? ""}
														disableClearable
														renderInput={(params) => <TextField {...params} label="Kaynak"/>}
														value={odeme.kaynak}
														onChange={(_event, value) => {
															const guncel = {...odeme};
															guncel.kaynak = value;
															guncelle(guncel);
														}}
													/>
												</Grid>
												<Grid item xs={12} sm={3}>
													<Autocomplete
														size={"small"}
														disabled={silinmis}
														disablePortal
														options={hesaplar.filter(q => q.hesapTipi === "Çalışan").map(q => q.id)}
														getOptionLabel={option => hesaplar.find(q => q.id === option)?.hesapAdi ?? ""}
														disableClearable
														renderInput={(params) => <TextField {...params} label="Çalışan"/>}
														value={odeme.kisi}
														onChange={(_event, value) => {
															const guncel = {...odeme};
															guncel.kisi = value;
															guncelle(guncel);
														}}
													/>
												</Grid>
												<Grid item xs={12} sm={2}>
													<TextField
														size={"small"}
														disabled={silinmis}
														fullWidth
														type={"number"}
														label={"Tutar"}
														InputProps={{ endAdornment: <Typography variant="caption" sx={{ ml: 1, fontWeight: 700 }}>₺</Typography> }}
														value={"" + odeme.miktar}
														onChange={(e) => {
															const guncel = {...odeme};
															guncel.miktar = floatParser(e.target.value);
															guncelle(guncel);
														}}
													/>
												</Grid>
												<Grid item xs={12} sm={1}>
													<Stack direction="row" spacing={1} justifyContent={{ xs: 'center', sm: 'flex-end' }}>
														<IconButton
															size="small"
															disabled={silinmis}
															onClick={() => {
																setPersonelOdemeleri({
																	...personelOdemeleri,
																	silinecekIdListe: [...personelOdemeleri.silinecekIdListe, odeme.id ?? 0],
																})
															}}
															color={"error"}
															sx={{ bgcolor: 'error.light', '&:hover': { bgcolor: '#ffcdd2' } }}
														>
															<Delete fontSize="small" />
														</IconButton>
														<IconButton
															size="small"
															disabled={!guncellenmis && !silinmis}
															onClick={() => {
																if (guncellenmis) {
																	setPersonelOdemeleri({
																		...personelOdemeleri,
																		guncellenecekIdListe: personelOdemeleri.guncellenecekIdListe.filter(id => id !== odeme.id),
																	})
																} else {
																	setPersonelOdemeleri({
																		...personelOdemeleri,
																		silinecekIdListe: personelOdemeleri.silinecekIdListe.filter(id => id !== odeme.id),
																	})
																}
															}}
															color={"info"}
															sx={{ bgcolor: 'info.light', '&:hover': { bgcolor: '#b3e5fc' } }}
														>
															<Undo fontSize="small" />
														</IconButton>
													</Stack>
												</Grid>
											</Grid>
										</CardContent>
									</Card>
								</Grid>
							)
						}
					)
				}
				{
					personelOdemeleri.eklenenListe.map((odeme, odemeIndex) => {
							const guncelle = (guncel: any) => {
								setPersonelOdemeleri({
									...personelOdemeleri,
									eklenenListe: personelOdemeleri.eklenenListe.map((o, index) => {
										if (index === odemeIndex) return guncel;
										return o;
									})
								})
							}
							return (
								<Grid item xs={12} key={"odeme_ekle-" + odemeIndex}>
									<Card
										elevation={0}
										sx={{
											border: '2px dashed',
											borderColor: 'success.main',
											backgroundColor: '#f1fff1',
											borderRadius: '12px'
										}}
									>
										<CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
											<Grid container spacing={1} alignItems="center">
												<Grid item xs={12} sm={3}>
													<Autocomplete
														size={"small"}
														options={["Avans", "Maaş", "Cari"]}
														renderInput={(params) => <TextField {...params} label="Ödeme Tipi"/>}
														value={odeme.tip}
														defaultValue={"Maaş"}
														onChange={(_event, value) => {
															const guncel = {...odeme};
															guncel.tip = value ?? "Maaş";
															guncelle(guncel);
														}}
													/>
												</Grid>
												<Grid item xs={12} sm={3}>
													<Autocomplete
														size={"small"}
														disablePortal
														options={hesaplar.filter(q => q.hesapTipi !== "Çalışan").map(q => q.id)}
														getOptionLabel={option => hesaplar.find(q => q.id === option)?.hesapAdi ?? ""}
														disableClearable
														renderInput={(params) => <TextField {...params} label="Kaynak"/>}
														value={odeme.kaynak}
														onChange={(_event, value) => {
															const guncel = {...odeme};
															guncel.kaynak = value;
															guncelle(guncel);
														}}
													/>
												</Grid>
												<Grid item xs={12} sm={3}>
													<Autocomplete
														size={"small"}
														disablePortal
														options={hesaplar.filter(q => q.hesapTipi === "Çalışan").map(q => q.id)}
														getOptionLabel={option => hesaplar.find(q => q.id === option)?.hesapAdi ?? ""}
														disableClearable
														renderInput={(params) => <TextField {...params} label="Çalışan"/>}
														value={odeme.kisi}
														onChange={(_event, value) => {
															const guncel = {...odeme};
															guncel.kisi = value;
															guncelle(guncel);
														}}
													/>
												</Grid>
												<Grid item xs={12} sm={2}>
													<TextField
														size={"small"}
														fullWidth
														type={"number"}
														label={"Tutar"}
														InputProps={{ endAdornment: <Typography variant="caption" sx={{ ml: 1, fontWeight: 700 }}>₺</Typography> }}
														value={"" + odeme.miktar}
														onChange={(e) => {
															const guncel = {...odeme};
															guncel.miktar = floatParser(e.target.value);
															guncelle(guncel);
														}}
													/>
												</Grid>
												<Grid item xs={12} sm={1} sx={{ display: 'flex', justifyContent: { xs: 'center', sm: 'flex-end' } }}>
													<IconButton
														size="small"
														onClick={() => {
															setPersonelOdemeleri({
																...personelOdemeleri,
																eklenenListe: personelOdemeleri.eklenenListe.filter((_, index) => index !== odemeIndex)
															})
														}}
														color={"error"}
														sx={{ bgcolor: 'error.light', '&:hover': { bgcolor: '#ffcdd2' } }}
													>
														<Delete fontSize="small" />
													</IconButton>
												</Grid>
											</Grid>
										</CardContent>
									</Card>
								</Grid>
							)
						}
					)
				}
				<Grid item xs={12} sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
					<Button
						variant="outlined"
						startIcon={<AddCircleOutline />}
						onClick={() => {
							setPersonelOdemeleri({
								...personelOdemeleri,
								eklenenListe: [
									...personelOdemeleri.eklenenListe,
									{
										tip: "Maaş",
										miktar: 0,
										kaynak: 0,
										kisi: 0,
									}]
							})
						}}
						sx={{ 
							borderRadius: '10px', 
							textTransform: 'none', 
							fontWeight: 700,
							px: 4,
							borderWidth: '2px',
							'&:hover': { borderWidth: '2px' }
						}}
					>
						Yeni Ödeme Ekle
					</Button>
				</Grid>
			</Grid>
		</AccordionDetails>
	</Accordion>
	);
}

export default Odemeler;